import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Units helpers
export const MGDL_TO_MMOL = 0.0555;

export function formatBg(value, units) {
  if (value === null || value === undefined) return "--";
  if (units === "mmol/L") return (value * MGDL_TO_MMOL).toFixed(1);
  return Math.round(value).toString();
}

export function formatDelta(delta, units) {
  if (delta === null || delta === undefined) return "";
  const sign = delta > 0 ? "+" : "";
  if (units === "mmol/L") return `${sign}${(delta * MGDL_TO_MMOL).toFixed(1)}`;
  return `${sign}${Math.round(delta)}`;
}

export const DIRECTION_ARROWS = {
  DoubleUp: "⇈",
  SingleUp: "↑",
  FortyFiveUp: "↗",
  Flat: "→",
  FortyFiveDown: "↘",
  SingleDown: "↓",
  DoubleDown: "⇊",
  NONE: "–",
};

export const DIRECTIONS = [
  "DoubleUp", "SingleUp", "FortyFiveUp", "Flat",
  "FortyFiveDown", "SingleDown", "DoubleDown", "NONE",
];

export function bgStatus(sgv, low, high) {
  if (sgv == null) return "neutral";
  if (sgv < low) return "urgent";
  if (sgv > high) return "high";
  return "in-range";
}

export function statusColor(status) {
  switch (status) {
    case "in-range": return "hsl(var(--sig-in-range))";
    case "high": return "hsl(var(--sig-high))";
    case "urgent": return "hsl(var(--sig-urgent))";
    default: return "hsl(var(--muted-foreground))";
  }
}

export function statusLabel(status) {
  return { "in-range": "In Range", high: "High", urgent: "Urgent", neutral: "No Data" }[status] || "";
}
